<template>
	<div class="hover-view">
		<div v-if="item" :class="['body', align]" :style="{
			gridTemplateColumns: gridTemplateColumns
		}">
			<div class="type" :style="{
				backgroundColor: _type.color
			}">
				<div class="label">{{ _type.label }}</div>
				<div class="tp"></div>
			</div>
			<div class="label">
				{{ item.name }}
				<div class="num">
					{{ item.num | integer }}
				</div>
			</div>
			<div class="info" style="width: 400px;">
				<table cellspacing="5" cellpadding="0">
					<tr>
						<td class="label">Telefon</td>
						<td class="value">{{ item.phone ? item.phone : '-' }}</td>
					</tr>
					<tr>
						<td class="label">Fax</td>
						<td class="value">{{ item.fax ? item.fax : '-' }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">E-mail</td>
						<td class="value">{{ item.email ? item.email : '-' }}</td>
					</tr>			
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Adresse</td>
						<td class="value">{{ item.address }}<br>{{ item.zip }} {{ item.city }}, {{ item.country }}</td>
					</tr>
				</table>
			</div>
			<div class="dyn team" style="width: 300px;">
				<div class="title">Detaljer</div>
				<div class="block" v-if="item.details != ''">
					<div class="desc">{{ item.details }}</div>
				</div>
				<div v-if="item.details == ''" class="block">
					<div class="desc">Ingen detaljer</div>
				</div>
			</div>
			<div class="dyn team" style="width: 300px;">
				<div class="title">Informationer</div>
				<div class="block" v-if="item.info != ''">
					<div class="desc">{{ item.info }}</div>
				</div>
				<div v-if="item.info == ''" class="block">
					<div class="desc">Ingen informationer</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				colors: {
					in: '#00c017',
					out: '#f7223f'
				}
			};
		},
		props: {
			date: {
				type: String,
				default: ''
			},
			item: {
				type: Object,
				default: null
			},
			align: {
				type: String,
				default: 'right'
			},
			types: {
				type: Object,
				default() {
					return {};
				}
			},
			employees: {
				type: Object,
				default() {
					return {};
				}
			},
			departments: {
				type: Object,
				default() {
					return {};
				}
			},
			instructions: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		methods: {
			
		},
		computed: {
			gridTemplateColumns() {
				var cols = ['30px', 'auto', 'auto', 'auto', 'auto'];

				cols.splice(cols.length - 2, 0, 'auto [semi]');

				return cols.join(' ') + ' [end]';
			},
			_type() {
				const bizz = this.item && this.item.roles && this.item.roles.business && this.item.roles.business.enabled;

				return {
					label: bizz ? 'Erhverv' : 'Privat',
					color: bizz ? '#0066ff' : '#00b33c'
				};
			}
		},
		watch: {
			types(n) {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hover-view {
		pointer-events: none;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		& > .body {
			&.left {
				left: 20px;
			}

			&.right {
				right: 20px;
			}

			background-color: white;
			border-radius: 5px;
			overflow: hidden;
			position: absolute;
			bottom: 20px;
			display: grid;
			grid-template-rows: auto 1fr 20px;

			-webkit-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			-moz-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);

			& > .type {
				color: white;
				font-weight: bold;
				grid-column: 1;
				grid-row: 1 / 4;
				position: relative;

				& > .label {
					position: absolute;
					bottom: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
					white-space: nowrap;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-left: 10px;
				}

				& > .tp {
					position: absolute;
					top: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-right: 10px;
				}
			}

			& > .label {
				grid-column: 2 / end;
				grid-row: 1;
				padding: 20px;
				font-size: 16px;
				font-weight: bold;

				& > .num {
					float: right;
					font-size: 16px;
					font-weight: bold;
				}
			}

			& > .info {
				padding: 0 30px 0 20px;
				max-width: 500px;
				
				& > table td {
					vertical-align: top;
					font-size: 14px;

					::v-deep .tag {
						display: inline-block;
						background-color: #f7223f;
						font-size: 12px;
						color: white;
						padding: 3px 5px 3px 5px;
						border-radius: 3px;
						margin-top: 4px;
						margin-bottom: 6px;
					}

					&.label {
						padding-right: 20px;
					}

					&.value {
						font-weight: bold;
					}

					&.sep {
						height: 10px;
					}

					&.right {
						text-align: right;
					}
				}

				&.events {
					padding-right: 20px;

					& table {
						margin-top: 10px;
						width: 100%;
					}

					& table td {
						font-size: 12px;
						border-top: 1px solid #e9e9e9;
					}

					& table tr:first-child td {
						border-top: none;
					}
				}
			}

			& > .dyn {
				border-left: 1px solid #e9e9e9;
				padding: 0 50px 0 20px;

				&.instr {
					max-width: 300px;
				}

				& > .title {
					font-weight: bold;
				}

				& > .block {
					padding-top: 10px;

					& > .title {
						font-size: 14px;
						font-weight: bold;
						margin-bottom: 3px;
					}

					& > .desc {
						padding-top: 5px;
						font-size: 14px;

						& > .status {
							display: inline-block;
							width: 6px;
							height: 6px;
							border-radius: 50%;
							margin-right: 8px;
							position: relative;
							top: -2px;
						}
					}
				}
			}
		}
	}
</style>